export const subscribedPlanInfoStyles = {
  modalTitle: {
    mt: '24px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
  },
  planName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '520',
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
  },
  subtitle: {
    mt: '4px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
  },
  subtitleValue: {
    marginLeft: '4px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: '520',
  },
  doneButtonStyles: {
    mt: '40px',
    padding: '14px 12px',
    borderRadius: '8px',
    textTransform: 'unset',
    backgroundColor: '#4D6EF5',
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: 400,
    color: '#fff',
    boxShadow: 'none',
    marginLeft: '12px',
    transition: '300ms',

    '&:hover': {
      opacity: '0.7',
      backgroundColor: '#4D6EF5',
      color: '#fff',
    },
  },
  doneBox: { display: 'flex', justifyContent: 'end', width: '100%' },
  chargingText: { display: 'flex', alignItems: 'center' },
};
